// noinspection JSVoidFunctionReturnValueUsed

module.exports = (function($) {
    let overlayIsOpen = false,
        overlayResizeTimeout,
        popupIsOpen = false,
        $doc = $(document),
        $win = $(window);

    $.overlay = {
        prop: {
            anim: {
                open: {
                    speed: 300
                },
                close: {
                    speed: 300
                }
            },
            opacity: .8,
            isInit: false,
            $overlay: null,
            $canvas: null
        },
        setWH: function() {
            if(!$.overlay.prop.isInit || !$.overlay.prop.$canvas) {
                return;
            }
            //$.overlay.prop.$overlay.css({width: $.overlay.prop.$canvas.width(), height: $.overlay.prop.$canvas.height()});
            $.overlay.prop.$overlay.css({width: '100%', height: $.overlay.prop.$canvas.height()});
        },
        init: function() {
            if($.overlay.prop.isInit) {
                return;
            }
            $.overlay.prop.$overlay = $('<div class="overlay" style="display: none;"></div>');
            $('body').append($.overlay.prop.$overlay);
            $.overlay.prop.isInit = true;
            $.overlay.setWH();

            $.overlay.prop.$overlay.on('click', function() {
                if($('body').find('.popup.is-open.close-on-overlay').length) {
                    $('body').trigger('overlay.click');
                }
            });


            $win.on('resize', function() {
                if(overlayIsOpen) {
                    clearTimeout(overlayResizeTimeout);
                    overlayResizeTimeout = setTimeout(function() {
                        $.overlay.setWH();
                    }, 100);
                }
            });
        },
        open: function(callback) {
            $.overlay.init();
            $.overlay.prop.$overlay.fadeTo($.overlay.prop.anim.open.speed, $.overlay.prop.opacity, callback);
            overlayIsOpen = true;
        },
        close: function() {
            if(!$.overlay.prop.isInit) {
                return;
            }
            $.overlay.prop.$overlay.fadeOut($.overlay.prop.anim.close.speed, function() {
                $('body').trigger('overlay.after_close');
            });
            overlayIsOpen = false;
        },
        isOpen: function() {
            return !!overlayIsOpen;
        }
    };

    var popupOpenTimeout = null;
    var popup = {
        open: function(selector, isClearErr, isResetForm) {
            clearInterval(popupOpenTimeout);
            popupOpenTimeout = setTimeout(function() {
                popup._open(selector, isClearErr, isResetForm);
            }, 200);
        },
        _open: function(selector, isClearErr, isResetForm) {
            var $popup = popup._getPopup(selector), st = $(window).scrollTop(),
                position,
                animationProp,
                animationSetup,

                isClearErr = isClearErr || true,
                isResetForm = isResetForm || true,

                slideIdx;

            if(typeof(selector) == 'string') {
                slideIdx = popup.getSlideNumberBySelector(selector);
            }

            if(!$popup || $popup.hasClass('is-open')) {
                if(slideIdx && slideIdx > 0) {
                    popup.moveToSlide(selector, slideIdx);
                }
                return;
            }
            else {
                popup.moveToSlide(selector, slideIdx, true);
            }

            if(!!isResetForm && !$popup.hasClass('not-reset')) {
                popup.resetForm($popup);
            }
            if(!!isClearErr) {
                popup.clearErrors($popup);
            }

            animationProp = $popup.attr('data-animation') || 'opacity';


            position = popup.getPosition($popup);

            if(position.top < st) {
                $popup.one('popup.open', function() {
                    $('html,body').animate({scrollTop: position.top}, 250);
                });
            }

            if(animationProp == 'right') {
                animationSetup = {
                    'right': position.right,
                    'opacity': 'show'
                }
                position.right = parseInt($popup.innerWidth())*-1;
            }
            else {
                animationSetup = {
                    'opacity': 'show'
                }
            }

            position.display = 'none';
            $popup.css(position);

            popup.closeAll();
            $.overlay.open(function() {
                $popup.trigger('popup.open');
                $popup.animate(animationSetup, 250, function() {
                    $('body').trigger('popup.after_open', $popup);
                }).addClass('is-open');
            });

            $('body').trigger('popup.open', $popup);
            popupIsOpen = true;
        },
        clearErrors: function($popup) {
            $popup.find('.error-message').each(function() {
                if(this.tagName.toLowerCase() == 'input') {
                    $(this).removeClass('error-message');
                }
                else {
                    $(this).remove();
                }
            });
            $popup.find('.js-focus').removeClass('js-focus');
        },
        resetForm: function($popup) {
            const $form = $popup.is('form') ? $popup : $popup.find('form');
            $form.each(function() {
                this.reset();
            });
            $popup.find('.hide').removeClass('hide');
            // $popup.find('img').each(function() {
            //     $img = $(this), $defaultImgSrc = $img.attr('data-default-url');
            //     if($defaultImgSrc) {
            //         $img.attr('src', $defaultImgSrc);
            //     }
            // });
        },
        close: function(isCloseOverlay) {
            $.overlay.close();
        },
        closeAll: function(isCloseOverlay, checkBtnClose) {
            var $popups = $('body').find('.popup.is-open');

            if(!!checkBtnClose && !$popups.find('.popup__btn-close, .js-close-button').length) {
                return;
            }

            $popups.animate({opacity: 'hide'}, 250, function() {
                $popups.filter('.temp').remove();
                if(!!isCloseOverlay) {
                    $.overlay.close();
                }
                $('body').trigger('popup.after_close', $popups);
                $(this).removeClass('is-open');
            });
            popupIsOpen = false;
        },
        rePosition: function(selector) {
            var $popup = popup._getPopup(selector),

                position = popup.getPosition($popup);
            $popup.css(position);
        },
        findRealWrapper: function($popup) {
            var $realWrapper = null;
            $popup.parents().each(function() {
                if($(this).css('position') == 'relative') {
                    $realWrapper = $(this);
                    return false;
                }
            });
            return $realWrapper;
        },
        getPosition: function($popup) {
            //console.info('$win', $win, $win.height(), $(window).height());
            var ww = $win.width(),
                wh = $win.height(),
                dw = $doc.width(),
                dh = $doc.height(),
                pw = $popup.outerWidth(),
                ph = $popup.outerHeight(),
                st = $win.scrollTop(),

                left = 0,
                top = 0,
                css = {},

                posType = $popup.attr('data-position'),

                $realWrapper = null;

            if($popup.hasClass('smart-positioning')) {
                $realWrapper = popup.findRealWrapper($popup);
                if($realWrapper) {
                    dw = $realWrapper.innerWidth();
                }
            }

            if($popup.css('position') == 'fixed') {
                st = 0;
            }


            if(dw >= pw) {
                left = Math.round((dw - pw)/2);
            }

            if(wh >= ph) {
                top = st+Math.round((wh - ph)/2);
            }
            else if(dh >= st+ph) {
                top = st;
            }
            else {
                top = Math.max(0, dh-ph);
            }

            if($popup.hasClass('vertically-center')) {
                css.top = top;
            } else {
                css.top = 0;
            }

            if(posType == 'right') {
                css.right = 0;
            }
            else {
                css.left = left;
            }

            return css;
        },
        _getPopup: function(selector) {
            var $popup, selectorsPart;

            if(typeof(selector) == 'object') {
                return selector;
            }
            if(typeof(selector) == 'string') {
                selectorsPart = selector.split('/');
            }

            $popup = $('#'+selectorsPart[0]);
            return $popup.length ? $popup : null;
        },
        getSlideNumberBySelector: function(selector) {
            var selectorsPart;
            if(typeof(selector) == 'string') {
                selectorsPart = selector.split('/');
                if(selectorsPart.length > 1) {
                    return selectorsPart[1];
                }
            }

            return false;
        },
        moveToSlide: function(selector, slideNumber, isNoAnim) {
            var $popup = popup._getPopup(selector), $slides, $newSlide, newSlidePos;

            if($popup.length) {
                if(!slideNumber) {
                    slideNumber = 0;
                }

                $slides = $popup.find('.popup__slide');
                if($slides.length > 0 && $slides.length >= slideNumber) {
                    $newSlide = $slides.eq(slideNumber-1);
                     newSlidePos = $newSlide.position();

                     if(isNoAnim) {
                         $popup.find('.popup__slide-wrapper').css({'left': (newSlidePos.left*-1)});
                     }
                     else {
                        $popup.find('.popup__slide-wrapper').animate({'left': (newSlidePos.left*-1)}, 350);
                    }
                }
            }
        },
        bind: function(selector, data) {
            var $popup = popup._getPopup(selector);

            if($popup && $popup.length) {
                $.each(data, function(key) {
                    var $el = $popup.find('[data-bind="'+key+'"]');
                    if($el.length) {
                        $el.each(function() {
                            if($(this).is(':input')) {
                                $(this).val(data[key]);
                            }
                            else {
                                $(this).text(data[key]);
                            }
                        });
                    }
                });
            }
        }
    };

    $.popup = popup;

    $.initPopups = (function() {
        $(document).on('click', '.open-popup', function(e) {
            var selector, isResetForm, isClearError;

            isClearError = !$(this).data('noclear-form');
            isResetForm = !$(this).data('noreset-form');

            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            if($(this).get(0).tagName == 'A') {
                selector = $(this).attr('href');
                popup.open(selector.substr(1), isClearError, isResetForm);
            }
            else {
                selector = $(this).data('popup')
                popup.open(selector, isClearError, isResetForm);
            }
        });

        $(document).on('click', '.popup__btn-close, .js-btn-close, .js-close-button', function(e) {
            e.preventDefault();
            popup.closeAll(true);
        })

        $(document).on('keydown', function(e) {
            if(e.keyCode == 27) {

                popup.closeAll(true, false);
            }
        });

        $(document).on('overlay.click', function() {
            popup.closeAll(true);
        });

        $win.on('resize.popup', function() {
            var $popups;

            if(popupIsOpen) {
                $('body').find('.popup.is-open').each(function() {
                    popup.rePosition($(this));
                });
            }
        });
    })()

    $.popup.info = function(text, options) {
        const popupId = `popup_temp_${Math.floor(Math.random()*1000000)}`;

        let addClasses = '';

        if (options && options['center']) {
            addClasses = 'vertically-center';
        }

        if(text) {
            $('body').append(`
                <section id="${popupId}" class="popup popup--info temp ${addClasses}">
                    <div class="popup__wrapper">
                        ${
                            text.map(item => `<p>${item}</p>`).join('')
                        }
                    </div>
                    <button type="button" class="popup__close-button js-close-button">
                        <svg>
                            <use xlink:href="#close_icon" x="0" y="0" />
                        </svg>
                    </button>
                </section>
            `);

            $.popup.open(`${popupId}`);
        }
    }

    $.popup.video = function(title, url) {
        const popupId = `popup_temp_${Math.floor(Math.random()*1000000)}`;

        if(url) {
            $('body').append(`
                <section id="${popupId}" class="popup popup--video temp">
                    <div class="popup__wrapper">
                        <header class="popup__header">${title}</header>

                        <video class="popup__video" controls>
                            <source src=${url} />
                        </video>
                    </div>
                    <button type="button" class="popup__close-button js-close-button">
                        <svg>
                            <use xlink:href="#close_icon" x="0" y="0" />
                        </svg>
                    </button>
                </section>
            `);

            $.popup.open(`${popupId}`);
        }
    }

})(require('jquery'));
